import React, { useEffect, useRef, useState } from 'react'
import { Tabs, Swiper } from 'antd-mobile'
import { BodyView, PopupSelectView, TabsView } from "../factory/ViewUtil";

import { SecondFuturesTradeViewController } from './SecondFuturesTradeViewController';
import { FuturesTradeViewController } from './FuturesTradeViewController';
import { CoinTradeViewController } from './CoinTradeViewController';
import { CellLastPriceView } from '../factory/CellViews';

const tabItems = [
    { key: '1', title: 'Second Futures' },
    { key: '2', title: 'Futures' },
    { key: '3', title: 'Coins' }
]

const TradeViewController = (props) => {

    const swiperRef = useRef(null)
    
    const secondFuturesRef = useRef(null)
    const futuresRef = useRef(null)
    const coinsRef = useRef(null)

    const [activeIndex, setActiveIndex] = useState(localStorage.getItem('tradeTabIndex') || 0)

    const [marketData, setMarketData] = useState([]);
    const [visiblePopup, setVisiblePopup] = useState(false);
    const [fromCall, setFromCall] = useState('-1');

    const updateTab = (index) => {
        setActiveIndex(index)
        localStorage.setItem('tradeTabIndex', index)
    }

    const visibleMarketPopup = (from) => {
        setVisiblePopup(true)
        setFromCall(from)
    }

    const selectedMarktData = (data) => {
        setVisiblePopup(false)
        if(fromCall === '1') {
            coinsRef.current.updateSymbolData(data)
        }
        else if(fromCall === '2') {
            futuresRef.current.updateSymbolData(data)
        }
        else if(fromCall === '3') {
            secondFuturesRef.current.updateSymbolData(data)
        }
    }

    //=========================================================
    // # 市场信息
    useEffect(() => {
        React.ListenerCandlestickDataSource('TradeViewController', (data) => {
            setMarketData(data)

            // # 动态更新
            for(let i = 0; i<data.length;i++) {
                const item = data[i]
                if(item.symbol === (secondFuturesRef.current?.currentSymbolData() || {}).symbol) {
                    secondFuturesRef.current?.updateSymbolData(item)
                }
                if(item.symbol === (futuresRef.current?.currentSymbolData() || {}).symbol) {
                    futuresRef.current?.updateSymbolData(item)
                }
                if(item.symbol === (coinsRef.current?.currentSymbolData() || {}).symbol) {
                    coinsRef.current?.updateSymbolData(item)
                }
            }
            
        });
        // # componentWillUnmount
        return () => {
            React.ListenerCandlestickRemove('TradeViewController')
        }
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    return(
        <>
            <div className='fixed-nav-bar'>
                <div style={{
                        display : 'flex',
                        height : '52px',
                        alignItems : 'center',
                        borderLeft : '18px transparent solid',
                        borderRight : '18px transparent solid',
                        boxSizing : 'border-box',
                    }}>
                    <TabsView activeKey={tabItems[activeIndex].key}
                        onChange={key => {
                            const index = tabItems.findIndex(item => item.key === key)
                            updateTab(index)
                            swiperRef.current?.swipeTo(index)
                    }}>
                        {tabItems.map(item => (
                            <Tabs.Tab title={item.title} key={item.key} />
                        ))}
                    </TabsView>
                </div>
            </div>
            <BodyView content={{style : {'border' : 'none'}}} style={{paddingTop : '52px', paddingBottom : '50px'}}>
                <Swiper direction='horizontal' indicator={() => null}
                    allowTouchMove={false}
                    ref={swiperRef}
                    defaultIndex={activeIndex}
                    onIndexChange={index => {
                        updateTab(index)
                    }}

                    style={{ height : '100%'}}
                    >
                        <Swiper.Item><SecondFuturesTradeViewController 
                            ref={secondFuturesRef} 
                            visibleMarketPopup={visibleMarketPopup}
                            {...props}
                            /></Swiper.Item>
                        <Swiper.Item><FuturesTradeViewController 
                            ref={futuresRef} 
                            visibleMarketPopup={visibleMarketPopup}
                            {...props}
                            /></Swiper.Item>
                        <Swiper.Item><CoinTradeViewController 
                            ref={coinsRef} 
                            visibleMarketPopup={visibleMarketPopup}
                            {...props}
                            /></Swiper.Item>
                </Swiper>
            </BodyView>

            <PopupSelectView visible={visiblePopup} close={()=>{setVisiblePopup(false)}}>
                {
                    marketData.map((item, index) => (
                        <CellLastPriceView
                            item={item}
                            key={index} 
                            onClick={()=>{selectedMarktData(item)}}
                            avatar={true}/>
                    ))
                }
            </PopupSelectView>

        </>
    );
}
export default React.memo(TradeViewController)